<style scoped lang="scss">
</style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/system/auth/user/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('yonghuzhanghao')">
						<el-input v-model="yt.conditions.username"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yonghumingcheng')">
						<el-input v-model="yt.conditions.nickname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')">
						<el-select v-model="yt.conditions.enabled">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽-->
			<!-- <template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template> -->
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
				</el-button> -->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 自定义某个字段 -->
			<!-- 角色 -->
			<template #juese="scope">
				<template>
					<span>{{scope.row.roleObjects | getRoleText}}</span>
					<!-- <span v-if="scope.row.roleObjects">{{scope.row.roleObjects | getRoleText}}</span>
					<span v-else>{{(scope.row.roleObjects | getRoleText) || ''}}</span> -->
				</template>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-col :span="0.1">
							<el-popconfirm title="确定重置密码？重置后密码：a12345678" confirm-button-text="重置"
								@confirm="resetSecret(scope.row)">
								<el-button type="text" slot="reference">{{$t('chongzhimima')}}</el-button>
							</el-popconfirm>
						</el-col>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<template #footer>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('yonghuzhanghao')">
						<el-input v-model="yt.editObj.username"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yonghumingcheng')">
						<el-input v-model="yt.editObj.nickname"></el-input>
					</el-form-item>
					<!-- <el-form-item :label="$t('yonghuleixing')">
						<el-input v-model="yt.editObj.type"></el-input>
					</el-form-item> -->
					<el-form-item :label="$t('shoujihaoma')">
						<el-input v-model="yt.editObj.mobile"></el-input>
					</el-form-item>
					<el-form-item :label="$t('Email')">
						<el-input v-model="yt.editObj.email"></el-input>
					</el-form-item>
					<el-form-item :label="$t('juese')">
						<el-select filterable :clearable="true" v-model="yt.editObj.roleIds" multiple collapse-tags>
							<el-option v-for="(item, index) in rolesList" :key="index" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="$t('shifouqiyong')">
						<el-select filterable :clearable="true" v-model="yt.editObj.enabled">
							<el-option v-for="(item, index) in status" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/system/auth/user/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>


			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('yonghuzhanghao')">
						<el-input disabled v-model="yt.editObj.username"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yonghumingcheng')">
						<el-input v-model="yt.editObj.nickname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shoujihaoma')">
						<el-input v-model="yt.editObj.mobile"></el-input>
					</el-form-item>
					<el-form-item :label="$t('Email')">
						<el-input v-model="yt.editObj.email"></el-input>
					</el-form-item>
					<el-form-item :label="$t('juese')">
						<yi_cross_select multiple :customerId="yt.editObj.customerId" :component="'web_system_role_list'" :ids.sync="yt.editObj.roleIds">
						</yi_cross_select>
					</el-form-item>

					<el-form-item :label="$t('shifouqiyong')">
						<el-select filterable :clearable="true" v-model="yt.editObj.enabled">
							<el-option v-for="(item, index) in status" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/system/auth/user/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'system_user_info_list',


		data() {
			return {
				status: [{
						label: "是",
						value: true
					},
					{
						label: "否",
						value: false
					}
				],
				list: [],
				rolesList: [],
				columns: [{
						label: 'yonghuzhanghao',
						prop: 'username',
						width: 150,
					},
					{
						label: 'yonghumingcheng',
						prop: 'nickname'
					},
					{
						label: 'shoujihaoma',
						prop: 'mobile'
					},
					{
						label: 'Email',
						prop: 'email',
					},
					{
						label: 'juese',
						// prop: 'roleObjects.name',
						type: 'slot'
					},
					{
						label: 'shifouqiyong',
						prop: 'enabled',
						type: 'bool',
						iln18: ['shi', 'fou'],
					},
					{
						label: 'caozuo',
						type: 'slot',
						width: 180,
						fixed: 'right',
					},
				],
			};

		},

		created() {
			setTimeout(() => {
				this.yt.SELECT_URL = '/web/system/auth/user/extend/listByIds';
				this.yt.SELECT_RESULT_KEY = 'data';
				this.yt.SELECT_ID = 'id';
				this.yt.SELECT_TITLE = 'nickname';

				this.yt.get(1);
				this.getList();
				this.getRolesList()
			}, 300)

		},
		filters: {
			getRoleText(value) {
				if (value != null) {
					return value.map(item => {
						return item.name
					}).join(",")
				}
				return '';
			}
		},
		methods: {
			resetSecret(editObj) {
				this.http.post('/web/system/auth/user/resetPwd', {
					id: editObj.id,
				}).then((res) => {
					this.utils.successMessage(this.$t(res.msg));
				}).catch((msg) => {
					this.utils.errorMessage(msg);
				})
			},
			async getRolesList() {
				let response = await this.http.get('/web/system/auth/role/page', {
					params: {
						pageNum: 1,
						pageSize: 10
					}
				})
				this.rolesList = response.data.rows
				console.log('ffff', response.data.rows)
			},
			// 获取列表数据
			async getList() {
				let response = await this.http.get('/web/system/auth/user/page', {
					params: {
						pageNum: 1,
						pageSize: 10
					}
				})
				console.log("list", response.data.rows)
				this.list = response.data.rows
			},
		},
	};
</script>
